module.exports = __webpack_public_path__ + "media/images/noshi-9c1d36a78601ff14be3524f9b0e3c54b.jpg";